/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.accountModule')
.controller('ResetPasswordController', ['$state','$stateParams','$translate','$window','BulbAuthService','BulbBusyService','BulbCoppaModalService','BulbErrorService','BulbModalService','Restangular', ResetPasswordController]);

function ResetPasswordController($state, $stateParams, $translate, $window, BulbAuthService, BulbBusyService,
                 BulbCoppaModalService, BulbErrorService, BulbModalService, Restangular) {
  var that = this;
  this.email = '';
  this.password = '';
  this.confirmPassword = '';
  this.showBadTokenError = false;
  if($stateParams.redirected) {
    this.redirected = $stateParams.redirected;
  } else {
    this.redirected = false;
  }
  this.isResetPasswordView = false;
  if ($stateParams.token) {
    this.isResetPasswordView = true;
    this.resetPasswordToken = $stateParams.token;
  }

  /**
   * Requests a new password link via email.
   * @param event event triggered
   */
  this.requestResetPassword = function(event) {
    if (this.email) {
      this.showBadTokenError = false;
      BulbBusyService.showBusyDuring(
        Restangular.all('accounts/passwordToken').post({email: that.email}).then(function(data) {
          that.showConfirmationDialog(event);
        }, function(error) {
          if (error.data.errorMap) {
            // allow the form controller to handle field validation errors:
            that.resetPasswordForm.handleRemoteErrors(error);
          } else {
            BulbErrorService.showError(null, error);
          }
        })
      );
    }
  };

  /**
   * Resets the password and then signs in the user.
   */
  this.resetPassword = function() {
    if (this.resetPasswordToken) {
      this.showBadTokenError = false;
      BulbBusyService.showBusyDuring(
        // DO LATER : modify the back-end AccountController and ResetPasswordDTO so that only one password is
        // needed by removing the second confirmPassword match validation.
        Restangular.all('accounts/newPassword').patch({password1: that.password,
          password2: that.confirmPassword, resetPasswordToken: that.resetPasswordToken}).then(
              function(loggedInAccount) {
          BulbAuthService.setCurrentUser(loggedInAccount.plain());
          $state.go('author', {username: BulbAuthService.currentUser.username});
        }, function(error) {
          if (error.data.errorMap) {
            var errorMap = error.data.errorMap;
            if (errorMap.fieldErrors.resetPasswordToken) {
              that.showBadTokenError = true;
              that.formError = errorMap.fieldErrors.resetPasswordToken;
              that.isResetPasswordView = false;
            } else {
              // allow the form controller to handle field validation errors:
              that.resetPasswordForm.handleRemoteErrors(error);
            }
          } else {
            if (error && error.data && error.data.developerMessage === 'Consent form not submitted.') {
              BulbCoppaModalService.showCOPPAactionModal();
            } else {
              BulbErrorService.showError(null, error);
            }
          }
        })
      );
    }
  };

  /**
   * Displays the look for a new password link email.
   * @param event event triggered.
   */
  this.showConfirmationDialog = function(event) {
    var modalOptions = {
      titleCode: 'reset_password_title',
      bodyCode: 'reset_password_look_for_email',
      showOkButton: false,
      showCancelButton: false,
      focusAfterClosed: event.currentTarget
    };
    BulbModalService.show(modalOptions);
  };

  /**
   * Handler for the Back button: Return to the location from whence we came.
   */
  this.goBack = function() {
    $window.history.back();
  };

}


